import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import {Menu, X, Users, Swords, Sparkles} from 'lucide-react';

export const Layout = ({ children }) => {
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);

    // Helper to close the menu when clicking a link
    const handleMenuClick = () => setMenuOpen(false);

    return (
        <div className="min-h-screen flex flex-col">
            {/* Navigation Header */}
            <nav className="bg-[#0f1a2a] shadow-sm border-b border-cyan-400/40">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between h-16">
                        <div className="flex items-center">
                            <Link to="/" className="text-xl font-bold text-gray-200">
                                League challenges
                            </Link>
                        </div>

                        {/* Desktop Navigation */}
                        <div className="hidden md:flex items-center space-x-8">
                            <Link
                                to="/"
                                className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                                    location.pathname === '/' 
                                        ? 'text-cyan-300'
                                        : 'text-gray-200 hover:text-cyan-400'
                                }`}
                            >
                                <Users size={16} />
                                Five Stack
                            </Link>
                            <Link
                                to="/aram-god"
                                className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                                    location.pathname === '/aram-god'
                                        ? 'text-cyan-300'
                                        : 'text-gray-200 hover:text-cyan-400'
                                }`}
                            >
                                <Sparkles size={16} />
                                Aram God
                            </Link>
                            <Link
                                to="/game"
                                className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                                    location.pathname === '/game'
                                        ? 'text-cyan-300'
                                        : 'text-gray-200 hover:text-cyan-400'
                                }`}
                            >
                                <Sparkles size={16} />
                                Game
                            </Link>
                        </div>

                        {/* Mobile menu button */}
                        <div className="md:hidden flex items-center">
                            <button
                                onClick={() => setMenuOpen(!menuOpen)}
                                className="text-gray-700 hover:text-gray-900"
                            >
                                {menuOpen ? <X size={24} /> : <Menu size={24} />}
                            </button>
                        </div>
                    </div>

                    {/* Mobile Navigation */}
                    {menuOpen && (
                        <div className="md:hidden">
                            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 border-t">
                                <Link
                                    to="/"
                                    onClick={handleMenuClick}
                                    className={`flex items-center gap-2 px-3 py-2 rounded-md text-base font-medium transition-colors ${
                                        location.pathname === '/'
                                            ? 'text-cyan-300'
                                            : 'text-gray-200 hover:text-cyan-400'
                                    }`}
                                >
                                    <Users size={16} />
                                    Five Stack
                                </Link>
                                <Link
                                    to="/aram-god"
                                    onClick={handleMenuClick}
                                    className={`flex items-center gap-2 px-3 py-2 rounded-md text-base font-medium transition-colors ${
                                        location.pathname === '/aram-god'
                                            ? 'text-cyan-300'
                                            : 'text-gray-200 hover:text-cyan-400'
                                    }`}
                                >
                                    <Sparkles size={16} />
                                    Aram God
                                </Link>
                                <Link
                                    to="/game"
                                    onClick={handleMenuClick}
                                    className={`flex items-center gap-2 px-3 py-2 rounded-md text-base font-medium transition-colors ${
                                        location.pathname === '/game'
                                            ? 'text-cyan-300'
                                            : 'text-gray-200 hover:text-cyan-400'
                                    }`}
                                >
                                    <Sparkles size={16} />
                                    Game
                                </Link>
                            </div>
                        </div>
                    )}
                </div>
            </nav>

            <main className="flex-grow bg-gray-50">
                {children}
            </main>

            {/* Hide footer on "/" */}
            {location.pathname !== "/" && (
                <footer className="bg-[#06060a] text-white py-6">
                    <div className="container mx-auto px-4">
                        <div className="flex justify-between items-center">
                            <div>© {new Date().getFullYear()} React App Template</div>
                            <div className="flex space-x-4">
                                <a href="#" className="hover:text-blue-400 transition">Terms</a>
                                <a href="#" className="hover:text-blue-400 transition">Privacy</a>
                            </div>
                        </div>
                    </div>
                </footer>
            )}
        </div>
    );
};
